import React from "react";

export default function CMSFaqManager({
  faqTitle = "",
  onChangeFaqTitle,
  faqs = [],
  onChangeFaqs,
}) {
  const handleAddFaq = () => {
    const updated = [...(faqs || []), { question: "", answer: "" }];
    onChangeFaqs(updated);
  };

  const handleUpdateItem = (index, field, value) => {
    const updated = [...(faqs || [])];
    updated[index] = {
      ...updated[index],
      [field]: value,
    };
    onChangeFaqs(updated);
  };

  const handleRemoveFaq = (index) => {
    if (window.confirm(`Are you sure you want to remove FAQ #${index + 1}?`)) {
      const updated = (faqs || []).filter((_, i) => i !== index);
      onChangeFaqs(updated);
    }
  };

  const handleMoveUp = (index) => {
    if (index === 0) return;
    const updated = [...(faqs || [])];
    const temp = updated[index - 1];
    updated[index - 1] = updated[index];
    updated[index] = temp;
    onChangeFaqs(updated);
  };

  const handleMoveDown = (index) => {
    if (index === (faqs || []).length - 1) return;
    const updated = [...(faqs || [])];
    const temp = updated[index + 1];
    updated[index + 1] = updated[index];
    updated[index] = temp;
    onChangeFaqs(updated);
  };

  return (
    <div className="col-12 mb-4">
      <div
        className="card"
        style={{
          border: "1px solid #fbc3dc",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(191, 50, 114, 0.08)",
          backgroundColor: "#fffdfd",
          overflow: "hidden",
        }}
      >
        <div
          className="card-header d-flex align-items-center justify-content-between flex-wrap"
          style={{
            background: "linear-gradient(135deg, #fff0f6 0%, #ffe3ee 100%)",
            borderBottom: "1px solid #fbc3dc",
            padding: "14px 18px",
          }}
        >
          <div>
            <h5 className="mb-0" style={{ fontWeight: 700, fontSize: "16px", color: "#bf3272" }}>
              <i className="fa fa-question-circle me-2" style={{ color: "#bf3272" }} />
              Page FAQs Management (Custom Q&amp;A)
            </h5>
            <small style={{ color: "#7a626c", fontSize: "12px" }}>
              Add page-specific FAQs. If empty, default system FAQs will automatically display on the live site.
            </small>
          </div>
          <button
            type="button"
            className="btn mt-2 mt-sm-0"
            onClick={handleAddFaq}
            style={{
              backgroundColor: "#bf3272",
              borderColor: "#bf3272",
              color: "#fff",
              fontWeight: 600,
              fontSize: "13px",
              padding: "6px 16px",
              borderRadius: "5px",
              transition: "all 0.3s ease",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = "#871749";
              e.currentTarget.style.borderColor = "#871749";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "#bf3272";
              e.currentTarget.style.borderColor = "#bf3272";
            }}
          >
            <i className="fa fa-plus me-1" /> Add FAQ
          </button>
        </div>

        <div className="card-body" style={{ padding: "18px" }}>
          <div className="mb-3">
            <label style={{ fontWeight: 600, color: "#333", fontSize: "14px" }}>
              FAQ Section Heading / Title (Optional)
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="e.g. Frequently Asked Questions or Bihar Matrimony FAQs"
              value={faqTitle}
              onChange={(e) => onChangeFaqTitle && onChangeFaqTitle(e.target.value)}
              style={{
                borderColor: "#fbc3dc",
                borderRadius: "5px",
              }}
            />
          </div>

          {!faqs || faqs.length === 0 ? (
            <div
              className="text-center py-4 px-3"
              style={{
                backgroundColor: "#fff7fa",
                borderRadius: "8px",
                border: "1px dashed #fbc3dc",
              }}
            >
              <i className="fa fa-info-circle mb-2" style={{ fontSize: "28px", color: "#bf3272" }} />
              <p className="mb-2" style={{ fontSize: "14px", color: "#666" }}>
                No custom FAQs added for this page yet.
              </p>
              <button
                type="button"
                className="btn btn-sm"
                onClick={handleAddFaq}
                style={{
                  color: "#bf3272",
                  border: "1px solid #bf3272",
                  backgroundColor: "#fff",
                  fontWeight: 600,
                  borderRadius: "5px",
                  padding: "5px 15px",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#bf3272";
                  e.currentTarget.style.color = "#fff";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#fff";
                  e.currentTarget.style.color = "#bf3272";
                }}
              >
                <i className="fa fa-plus me-1" /> Add First FAQ
              </button>
            </div>
          ) : (
            <div className="faq-list-container">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="card mb-3"
                  style={{
                    border: "1px solid #f3d1e1",
                    borderRadius: "6px",
                    backgroundColor: "#fff",
                    boxShadow: "0 1px 4px rgba(191, 50, 114, 0.05)",
                  }}
                >
                  <div
                    className="card-header d-flex justify-content-between align-items-center py-2 px-3 flex-wrap"
                    style={{
                      background: "#fff9fb",
                      borderBottom: "1px solid #f8e1ec",
                    }}
                  >
                    <span style={{ fontWeight: 600, fontSize: "14px", color: "#bf3272" }}>
                      <span
                        className="badge me-2"
                        style={{
                          backgroundColor: "#bf3272",
                          color: "#fff",
                          fontWeight: 600,
                          fontSize: "12px",
                          borderRadius: "4px",
                          padding: "4px 8px",
                          marginRight: "5px"
                        }}
                      >
                        #{index + 1}
                      </span>
                      {faq.question
                        ? faq.question.substring(0, 65) + (faq.question.length > 65 ? "..." : "")
                        : "New FAQ Item"}
                    </span>
                    <div className="btn-group btn-group-sm mt-1 mt-sm-0">
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        title="Move Up"
                        disabled={index === 0}
                        onClick={() => handleMoveUp(index)}
                        style={{ fontSize: "11px", padding: "3px 8px" }}
                      >
                        <i className="fa fa-arrow-up" />
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        title="Move Down"
                        disabled={index === faqs.length - 1}
                        onClick={() => handleMoveDown(index)}
                        style={{ fontSize: "11px", padding: "3px 8px" }}
                      >
                        <i className="fa fa-arrow-down" />
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm"
                        title="Delete FAQ"
                        onClick={() => handleRemoveFaq(index)}
                        style={{
                          fontSize: "11px",
                          padding: "3px 8px",
                          color: "#dc3545",
                          borderColor: "#f5c2c7",
                          backgroundColor: "#fff",
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.backgroundColor = "#dc3545";
                          e.currentTarget.style.color = "#fff";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.backgroundColor = "#fff";
                          e.currentTarget.style.color = "#dc3545";
                        }}
                      >
                        <i className="fa fa-trash" />
                      </button>
                    </div>
                  </div>
                  <div className="card-body p-3">
                    <div className="mb-2">
                      <label style={{ fontSize: "13px", fontWeight: 600, color: "#333" }}>
                        Question <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="e.g. How much is the membership?"
                        value={faq.question || ""}
                        onChange={(e) => handleUpdateItem(index, "question", e.target.value)}
                        style={{
                          borderColor: "#f3d1e1",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                    <div>
                      <label style={{ fontSize: "13px", fontWeight: 600, color: "#333" }}>
                        Answer <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows={3}
                        placeholder="Enter clear and helpful answer (supports line breaks)..."
                        value={faq.answer || ""}
                        onChange={(e) => handleUpdateItem(index, "answer", e.target.value)}
                        style={{
                          borderColor: "#f3d1e1",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
              <div className="text-end mt-2">
                <button
                  type="button"
                  className="btn btn-sm"
                  onClick={handleAddFaq}
                  style={{
                    color: "#bf3272",
                    border: "1px solid #bf3272",
                    backgroundColor: "#fff0f6",
                    fontWeight: 600,
                    borderRadius: "5px",
                    padding: "6px 16px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#bf3272";
                    e.currentTarget.style.color = "#fff";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#fff0f6";
                    e.currentTarget.style.color = "#bf3272";
                  }}
                >
                  <i className="fa fa-plus me-1" /> Add Another FAQ
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
